import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", { class: "q-ml-sm q-ma-none text-weight-bold" }, "Fordonsvård", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppLogo = _resolveComponent("AppLogo")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_SignInForm = _resolveComponent("SignInForm")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_page = _resolveComponent("q-page")!
  const _component_q_page_container = _resolveComponent("q-page-container")!

  return (_openBlock(), _createBlock(_component_q_page_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_q_page, { class: "flex justify-center items-center q-pa-sm bg-primary" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card, {
            class: "full-width",
            style: {"max-width":"400px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, { class: "flex items-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_AppLogo, { size: "lg" }),
                  _createVNode(_component_q_separator, {
                    class: "q-ml-sm",
                    vertical: "",
                    inset: ""
                  }),
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createVNode(_component_SignInForm)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}